import React from "react";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import FilingForm from "../../../common/form/filing/FilingForm";

const SEOfficialNoteStepFiling = () => {
  const seOfficialNoteForm = useAppSelector((state) => {
    return state.Forms.SEOfficialNoteForm;
  });

  return (
    <FilingForm
      basePath={baseEndpointPaths.seRecognition}
      appId={seOfficialNoteForm.id}
      redirectPath={"/se-application"}
      allowedFileApplicationAction={false}
    />
  );
};
export default SEOfficialNoteStepFiling;
